import { render, staticRenderFns } from "./TripRating.vue?vue&type=template&id=02bc4008&scoped=true&"
import script from "./TripRating.vue?vue&type=script&lang=js&"
export * from "./TripRating.vue?vue&type=script&lang=js&"
import style0 from "./TripRating.vue?vue&type=style&index=0&id=02bc4008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bc4008",
  null
  
)

export default component.exports